import React from 'react'
import { Badge } from '../index'
import * as colors from '../../assets/js/colors'

export default function PickingAreaStatus({ status }) {
  // Render
  if (status === 'Em Separação') {
    return <Badge color={colors.laranja}>Pendente</Badge>
  } else {
    return <Badge color={colors.verde}>OK</Badge>
  }
}
